import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { l10n } from '../i18n/Localization';

class BackButton extends Component {
    goBack = () => {
        const history = this.props.history;

        history.goBack();
    }

    render() {
        const disabled = this.props.disabled;

        return (
            <button className="btn btn-secondary" type="button" onClick={this.goBack} disabled={disabled}><i className="bi-arrow-left-square mr-2"></i>{l10n.action.back}</button>
        );
    }
}

export default withRouter(BackButton);
